/*
 * Copyright (c) 2025 by PROS, Inc.  All Rights Reserved.
 * This software is the confidential and proprietary information of
 * PROS, Inc. ("Confidential Information").
 * You may not disclose such Confidential Information, and may only
 * use such Confidential Information in accordance with the terms of
 * the license agreement you entered into with PROS.
 */
import { __decorate } from "tslib";
import { html, css, LitElement } from 'lit';
import { customElement, property, query } from 'lit/decorators.js';
/**
 * WebComponent.
 */
let PwcHighcharts = class PwcHighcharts extends LitElement {
    constructor() {
        super(...arguments);
        // observe the container where highcharts is added and reflows as it is resized
        this._ro = new ResizeObserver(() => {
            if (this._chart) {
                this._chart.reflow();
            }
        });
    }
    disconnectedCallback() {
        // eslint-disable-next-line wc/guard-super-call
        super.disconnectedCallback();
        // clean up observer
        this._ro.unobserve(this._outlet);
        this._ro.disconnect();
        // purge highcharts and cleanup reference if there is a chart rendered
        if (this._chart) {
            this._chart.destroy();
            this._chart = undefined;
        }
    }
    firstUpdated() {
        // observe the outlet for changes in size
        this._ro.observe(this._outlet);
    }
    /**
     * @override
     */
    updated(_changedProperties) {
        // render the text.
        if (_changedProperties.has('data')) {
            // eslint-disable-next-line no-undef
            const highcharts = globalThis.Highcharts || globalThis.AiChatHighcharts;
            if (typeof highcharts !== 'undefined') {
                const mergedConfig = {
                    // must-have highcharts config that all charts should include
                    credits: {
                        enabled: false, // removes highcharts watermark
                    },
                    exporting: {
                        fallbackToExportServer: false, // prevents falling back to highcharts servers for generating export images/pdf
                    },
                    ...this.data,
                };
                highcharts.chart(this._outlet, mergedConfig, (chart) => {
                    this._chart = chart;
                });
            }
        }
    }
    /**
     * @inheritdoc
     */
    render() {
        return html ` <div class="outlet"></div> `;
    }
};
// styles.
// we want highcharts to take as much spaces as possible in chat bubble
// outlet width where highcharts is rendered in is calculated as
// 100% of message width (chat bubble part) - some inner margins
PwcHighcharts.styles = css `
    :host {
      display: flex;
      width: 100%;
    }

    .outlet {
      width: calc(
        var(--pwc-ai-chat-message-width) - (5 * var(--pwc-ai-chat-inner-margin))
      );
    }
  `;
__decorate([
    property({ attribute: false })
], PwcHighcharts.prototype, "data", void 0);
__decorate([
    query('.outlet', true)
], PwcHighcharts.prototype, "_outlet", void 0);
PwcHighcharts = __decorate([
    customElement('pwc-highcharts')
], PwcHighcharts);
export { PwcHighcharts };
//# sourceMappingURL=pwc-highcharts.js.map